module.exports = __webpack_public_path__ + "img/eth_miner_temps_web.5b04b354.jpg";